"use client";

import {DentwyzePresetLists, LocalityNameById, PresetListKey} from "../types";
import React, {ReactElement, useEffect, useState} from "react";
import {KeyTextString} from "../../shared/types";
import {Box, FormControl, MenuItem, Select, Typography} from "@mui/material";
import {DW_XS, PD_SM} from "../../shared/dimens";
import {FormGenContainerMode} from "../../shared/FormGenContainer";

export function LocalitySelect(props: {
  key: string,
  presetLists: DentwyzePresetLists,
  cityId: string,
  value: string,
  setValue: (value: string) => void
}): ReactElement {
  const [cityId, setCityId] = useState<string>(props.cityId);
  const [enumValues, setEnumValues] = useState<KeyTextString[]>([]);
  useEffect(() => {
    if (props.cityId !== cityId) {
      props.setValue(undefined);
    }
    setEnumValues([]);
    setCityId(props.cityId);
  }, [props.cityId]);
  useEffect(() => {
    (async function () {
      if (cityId) {
        const list = await props.presetLists.getOrLoadList(PresetListKey.LOCALITIES, [[":cityId", cityId]]);
        list.values.sort((kts1, kts2) => kts1.text.localeCompare(kts2.text));
        setEnumValues(list.values);
      } else {
        setEnumValues([]);
      }
    })();
  }, [cityId]);
  return <Box display="flex" flexDirection="row" style={{gap: PD_SM}}>
    <FormControl variant="outlined">
      <Select
        key={`${props.key}-select`}
        variant={"outlined"}
        MenuProps={{
          style: {zIndex: 10000}
        }}
        size="small"
        sx={{width: DW_XS}}
        value={props.value || ""}
        onChange={event => {
          props.setValue(event.target.value);
        }}>
        {enumValues.map(value => {
          return <MenuItem value={value.key}>
            {value.text}
          </MenuItem>;
        })}
      </Select>
    </FormControl>
  </Box>
}

export function LocalityName({cityId, localityId}: { cityId: string, localityId: string }): ReactElement {
  const [locality, setLocality] = useState<string>();
  useEffect(() => {
    if (cityId && localityId) {
      LocalityNameById(cityId, localityId).then(locality => setLocality(locality));
    } else {
      setLocality(null);
    }
  }, [cityId, localityId]);
  return <Typography>{locality}</Typography>;
}

export function renderLocalitySelect(cityId: string, value: string, setValue: (value: string) => void, mode: FormGenContainerMode) {
  switch (mode) {
    case FormGenContainerMode.READ:
      return <LocalityName cityId={cityId} localityId={value}/>;
    default:
      return <LocalitySelect
        key={cityId}
        presetLists={DentwyzePresetLists.getInstance()}
        cityId={cityId}
        value={value}
        setValue={setValue}/>;
  }
}

